export const PLATFORM_URL: string = 'https://meta.feedonomics.com/app/#/';
export const PREPROCESS_URL: string = 'https://preprocess.proxy.feedonomics.com/preprocess/run_preprocess.php?';
export const API_BASE_URL: string = '/api.php';

// #region FQL constants
export const CARRIAGE_RETURN: string = '\r';
export const NEWLINE: string = '\n';
export const CARRIAGE_RETURN_AND_NEWLINE: string = `${CARRIAGE_RETURN}${NEWLINE}`;
// #endregion

/**
 * This is the default value for a schedule that has never run, such as for an import or export that has not
 * been executed yet.
 */
export const EMPTY_TIMESTAMP: string = '0000-00-00 00:00:00';
export const DEFAULT_PAGE_SIZE: number = 100;
/**
 * `field_name` key used by the platform to identify the delta_status export field.
 */
export const DELTA_STATUS_FIELD_NAME: string = '{{feedonomics::delta_status}}';
export const GENERAL_EXPORT: string = 'General export';

// #region Bootstrap constants
export const NG_BOOTSTRAP_ANIMATION_DELAY: number = 200;
export const NG_BOOTSTRAP_OPEN_DELAY: number = 500;
// #endregion
